import { useContext, useState } from 'react';
import { useTranslation } from 'react-i18next';

import { Button, Typography } from 'mobily-ui-library/lib';
import { GlobalContext } from '../../context/GlobalContext';

import HeaderNavigation from '../HeaderNavigation/HeaderNavigation';
import DeviceTNC from './DeviceTNC';

import './DeviceTerms.scss';

interface Props {
    handleHeaderCancel: () => void;
}

function DeviceTerms({ handleHeaderCancel }: Props) {
    const { state, dispatch }: any = useContext(GlobalContext);
    const { rtl, selectedAcPlan, isInstallmentApplied, isSubsidyApplied } = state;

    const { t } = useTranslation();

    const [checked, setChecked] = useState(false);

    const acName = selectedAcPlan?.acName;

    const handleCheckbox = () => {
        setChecked(prevState => !prevState)
    }

    const handleBackArrow = () => {
        dispatch({ type: 'CURRENT_PAGE', payload: { currentPage: "cartPage" } })
    }

    const handleAddCoverage = () => {
        if (acName.includes("AppleCare+ warranty recurring")) {
            dispatch({ type: "LOADER", payload: { loading: true } });
            dispatch({ type: 'CURRENT_PAGE', payload: { currentPage: "TermsOTP" } });
        } else {
            if (isInstallmentApplied || isSubsidyApplied) {
                dispatch({ type: 'CURRENT_PAGE', payload: { currentPage: "TermsOTP" } });
            } else {
                dispatch({ type: 'CURRENT_PAGE', payload: { currentPage: "TwoYearCoverageLogin" } });
            }
        }
    }

    return (
        <div className='DeviceTermsNCondition__Container'>
            <HeaderNavigation
                rtl={rtl}
                percent={100}
                showBackArrow={true}
                handleBackArrow={handleBackArrow}
                handleHeaderCancel={handleHeaderCancel}
            />

            <DeviceTNC></DeviceTNC>

            {/* sticky terms n condition */}
            <div className='DTNC__StickyBox'>
                <div className='STB__Container_terms_ac'>
                    <div className='STB__TnC'>
                        <input aria-label='checkbox' type='checkbox' onChange={handleCheckbox} className='STB__Checkbox' />
                        <Typography rtl={rtl} id="lineType-heading" className='STB__Text'>{t('Accept_TermsNcondition')}</Typography>
                    </div>
                    <Button
                        rtl={rtl}
                        className={`STB__ApplyBtn ApplyBtn_sub`}
                        variant={!checked ? 'disabled' : 'default'}
                        onClick={handleAddCoverage}
                    >
                        {t('Add_coverage')}
                    </Button>
                </div>
            </div>
        </div>
    )
}

export default DeviceTerms